// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"f1dfce92","container":"c5f2a9ec","notification":"d2740be0","positive":"da175690","error":"e41ccc4b","neutral":"f5937e18"};